var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125.625h-6.25C5.839.625 5 1.465 5 2.5v15c0 1.035.84 1.875 1.875 1.875h6.25c1.036 0 1.875-.84 1.875-1.875v-15c0-1.036-.84-1.875-1.875-1.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875.625h.938a.31.31 0 0 1 .312.312.625.625 0 0 0 .625.625h2.5a.625.625 0 0 0 .625-.625.31.31 0 0 1 .313-.312h.937"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff"
  })))));
};
export { SvgPhone as ReactComponent };